import type { LookupFieldValue } from "@smartsuite/types";
import type { FieldRegistryConfig } from "../../types";
import { defaultToReviewString } from "../review/reviewString.helpers";
import { LookupFieldControl } from "./LookupFieldControl/LookupFieldControl";

/** Lookup field value in form state: nested array of looked-up values used for conditional logic; not submitted. */
export type LookupFormValue = LookupFieldValue | null;

export const lookupFieldConfig: FieldRegistryConfig<LookupFormValue> = {
  icon: "lookup",
  control: LookupFieldControl,
  // No convertFormValueToApi - Lookup values are excluded from submission in converter.
  toReviewString: defaultToReviewString,
};
